import { useState } from "react";
import { Button, Form, Input, message, Card, Typography } from "antd";
import { useNavigate, useLoaderData } from "react-router-dom";
import axiosInstance from "./axiosInstance";
import axios from "axios";

const { Title } = Typography;

interface ChangePasswordFormValues {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

const ChangePassword = () => {
  const navigate = useNavigate();
  const { user } = useLoaderData() as { user: any };
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const handleChangePassword = async (values: ChangePasswordFormValues) => {
    try {
      setLoading(true);
      
      // First, validate the current password by attempting to authenticate
      try {
        await axios.post("https://melcarnedirectus2.digipulse.ch/auth/login", {
          email: user.email,
          password: values.currentPassword
        });
      } catch (authError) {
        messageApi.open({
          type: "error",
          content: "Le mot de passe actuel est incorrect!",
          duration: 5,
        });
        return;
      }
      
      // If current password is correct, update to new password
      await axiosInstance.patch("/users/me", {
        password: values.newPassword
      });

      messageApi.open({
        type: "success",
        content: "Votre mot de passe a été changé avec succès!",
        duration: 3,
      });

      // Redirect to home page after successful password change
      setTimeout(() => {
        navigate("/");
      }, 1500);

    } catch (error: any) {
      console.error(error);
      let errorMessage = "Une erreur s'est produite lors du changement de mot de passe.";
      
      if (error.response?.data?.errors) {
        errorMessage = error.response.data.errors[0]?.message || errorMessage;
      }

      messageApi.open({
        type: "error",
        content: errorMessage,
        duration: 5,
      });
    } finally {
      setLoading(false);
    }
  };

  const validateConfirmPassword = (_: any, value: string) => {
    if (!value || form.getFieldValue('newPassword') === value) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('Les mots de passe ne correspondent pas!'));
  };

  return (
    <>
      {contextHolder}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "80vh",
          padding: "20px",
        }}
      >
        <Card style={{ width: 400, boxShadow: "0 4px 8px rgba(0,0,0,0.1)" }}>
          <div style={{ textAlign: "center", marginBottom: 24 }}>
            <Title level={3}>Changer de mot de passe</Title>
          </div>
          
          <Form
            form={form}
            name="change-password"
            onFinish={handleChangePassword}
            layout="vertical"
            requiredMark={false}
          >
            <Form.Item
              label="Mot de passe actuel"
              name="currentPassword"
              rules={[
                {
                  required: true,
                  message: "Veuillez saisir votre mot de passe actuel!",
                },
              ]}
            >
              <Input.Password
                size="large"
                placeholder="Entrez votre mot de passe actuel"
              />
            </Form.Item>

            <Form.Item
              label="Nouveau mot de passe"
              name="newPassword"
              rules={[
                {
                  required: true,
                  message: "Veuillez saisir votre nouveau mot de passe!",
                },
                {
                  min: 8,
                  message: "Le mot de passe doit contenir au moins 8 caractères!",
                },
              ]}
            >
              <Input.Password
                size="large"
                placeholder="Entrez votre nouveau mot de passe"
              />
            </Form.Item>

            <Form.Item
              label="Confirmer le nouveau mot de passe"
              name="confirmPassword"
              dependencies={['newPassword']}
              rules={[
                {
                  required: true,
                  message: "Veuillez confirmer votre nouveau mot de passe!",
                },
                {
                  validator: validateConfirmPassword,
                },
              ]}
            >
              <Input.Password
                size="large"
                placeholder="Confirmez votre nouveau mot de passe"
              />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                loading={loading}
                style={{ width: "100%", marginBottom: 16 }}
              >
                Changer le mot de passe
              </Button>
              
              <Button
                size="large"
                onClick={() => navigate("/")}
                style={{ width: "100%" }}
              >
                Annuler
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </>
  );
};

export default ChangePassword;
